const loco = window.location;
let appRootUrl = `${loco.protocol}//${loco.host}${process.env.BASE_URL}`;
if (appRootUrl[appRootUrl.length - 1] === '/') {
  appRootUrl = appRootUrl.substr(0, appRootUrl.length - 1);
}

export default {
  authority: process.env.VUE_APP_AUTH_URL,
  client_id: process.env.VUE_APP_AUTH_CLIENT_ID,
  redirect_uri: `${appRootUrl}/callback`,
  silent_redirect_uri: `${appRootUrl}/callback`,
  scope: process.env.VUE_APP_AUTH_SCOPE,
  post_logout_redirect_uri: `${appRootUrl}/logout`,
  response_type: 'id_token token',
  loadUserInfo: true,
  revokeAccessTokenOnSignout: true
};
